import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { teamStore } from 'state/team/team'
import CoachForm from './ModalContent/CoachForm'

interface ManageCoachProps {
  teamId: string
  organizationId: string
  refetch: () => void
}

const ManageCoach: React.FC<ManageCoachProps> = ({ teamId, organizationId, refetch }) => {
  const { coachModalVisible, setCoachModalVisible } = teamStore(store => ({
    coachModalVisible: store.coachModalVisible,
    setCoachModalVisible: store.setCoachModalVisible,
  }))

  return (
    <CustomModal
      openModal={coachModalVisible}
      closeModal={setCoachModalVisible}
      title="Add Coach"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Close"
          onSubmit={() => setCoachModalVisible(false)}
        />
      }
    >
      <CoachForm teamId={teamId} organizationId={organizationId} onSuccess={refetch} />
    </CustomModal>
  )
}

export default ManageCoach
